import { icon } from "leaflet";
import DollarSignIcon from "../../../Components/Common/svg/reports/dollarsign";
import { DateRangeIcon } from "@mui/x-date-pickers";
import MoneyBagIcon from "../../../Components/Common/svg/reports/moneybagicon";
import { formatPrice } from "../../../utils/formatPrice"; 

export const tabs = [
  { id: 3, label: "account", name: "الحساب" },
  { id: 4, label: "orders", name: "الطلبات" },
  { id: 5, label: "workingDays", name: "المحفظة" },
  { id: 6, label: "location", name: "العناوين" },
];

export const userShowConfigStats = (statsUsers) => [
  {
    title: " إجمالي الطلبات",
    count: statsUsers?.total_orders,
    color: "#0F2B42",
    bgIcon: "#E7EAEC",
    icon: <DollarSignIcon />,
  },
  {
    title: "إجمالي الإنفاق",
    count: formatPrice(100, statsUsers?.total_spending),
    color: "#00835B",
    bgIcon: "#E6F3EF",
    icon: <MoneyBagIcon />,
  },
  {
    title: "رصيد المحفظة",  
    count: formatPrice(100, statsUsers?.wallet_balance),
    color: "#EB5757",
    bgIcon: "#FDECEC",
    icon: <DollarSignIcon />,
  },
  {
    title: "متوسط ​​التقييم",
    count: statsUsers?.average_rating,
    color: "#EB5757",
    bgIcon: "#FDECEC",
  },
  {
    title: "الحساب منذ",
    count: statsUsers?.account_since,
    color: "#EB5757",
    bgIcon: "#FDECEC",
    icon: <DateRangeIcon />,
  },
];
